<template>
  <div>
    <!-- 公司设备 -->
    <device-list deviceType="SBGXFL_A"></device-list>
  </div>
</template>

<script>
import DeviceList from "./DeviceList.vue";
export default {
  components: {
    DeviceList,
  },
};
</script>

<style lang="scss" scoped></style>
